import { IApplicationState } from '../../types/redux';
import { selectAppropriateUserPhone } from './userPhone';

type TUserBaseInfo = {
  email: string;
  phone: string;
  firstName: string;
  isAuthenticated: boolean;
};

export function selectUserBaseInfo(state: IApplicationState): TUserBaseInfo {
  const { user } = state;
  const phone = selectAppropriateUserPhone(state)?.phone || '';

  if (user.isAuthenticated) {
    return {
      email: user.email || '',
      phone,
      firstName: user.firstName || '',
      isAuthenticated: user.isAuthenticated,
    };
  }

  return {
    email: '',
    firstName: '',
    phone,
    isAuthenticated: user.isAuthenticated,
  };
}
